// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.grid-att[data-v-498c8c9a] {\n  display: grid;\n  grid-template-columns: auto auto auto;\n}\n@media screen and (max-width: 1050px) {\n.grid-att[data-v-498c8c9a] {\n    grid-template-columns: auto auto;\n}\n}\n@media screen and (max-width: 850px) {\n.grid-att[data-v-498c8c9a] {\n    grid-template-columns: auto;\n}\n}\n\n", ""]);
// Exports
module.exports = exports;
